module.exports = __webpack_public_path__ + "img/icon-invoice-download.0394e5e7.svg";